// Turns an uploaded file back into a File, e.g. to send it on with a new order. Only the
// path is used: the /files proxy serves it from the app's own origin, whereas the full
// address may point at the back end's host and be blocked by CORS.
export const fileFromUrl = async (url) => {
  const { pathname } = new URL(url, window.location.origin);
  const response = await fetch(pathname);
  if (!response.ok) {
    throw new Error(`Could not fetch ${pathname} (${response.status})`);
  }
  const blob = await response.blob();
  const name = decodeURIComponent(pathname.split("/").pop() || "file");
  return new File([blob], name, { type: blob.type });
};
